<template>
  <div class="preview_box">
    <div class="phone_wrap">
      <div class="phone_Item" :style="activityBgImg">
        <div v-if="customRuleJson.isOpenMusic" class="music_box">
          <img :src="musicImgUrl" width="24px" height="24px" />
        </div>
        <div class="header">
          <img
            src="https://cdn-image.yucrm.cn/images/tb/funGamesImg/header.png"
            width="100%"
          />
        </div>
        <div class="phone-content-container">
          <div
            class="phone-content"
            :style="{ color: customRuleJson.reportTextColor }"
          >
            <div class="txt-row">每一笔订单</div>
            <div class="txt-row">
              都是你与<span class="txt-bold">店铺名称</span>的故事
            </div>
            <div class="txt-row">新的一年，愿我们继续彼此陪伴</div>
            <div class="txt-row">现在，快去领取许愿币</div>
            <div class="txt-row">去许愿获得你的专属礼包吧！</div>
          </div>
          <div class="phone-btn-box">
            <div
              class="phone-btn"
              :style="{
                backgroundImage: `url(${customRuleJson.endBtnUrl})`,
                color: customRuleJson.endBtnColor,
              }"
            >
              {{ customRuleJson.endBtnText }}
            </div>
            <div class="tip-txt">返回再看一遍</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "previewReportEnd",
  props: {
    customerPaperwork: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
  computed: {
    customRuleJson() {
      return (this.customerPaperwork && this.customerPaperwork.reoprtObj) || {};
    },
    musicImgUrl() {
      // 1深色 2浅色
      let typeMap = {
        1: "light",
        2: "dark",
      };
      return `https://cdn-image.yucrm.cn/images/dy/makeAwish/${
        typeMap[this.customRuleJson.iconColor]
      }_icon_open.png`;
    },
    activityBgImg() {
      return {
        backgroundImage: `url(${this.customRuleJson.reportEnd})`,
        backgroundSize: "103% 118%",
        // backgroundPosition: "center center",
        backgroundRepeat: "no-repeat",
        borderRadius: "8px",
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.preview_box {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}
.phone_wrap {
  position: relative;
  width: 294px;
  height: 564px;
  border-radius: 8px;
  background: #ffffff33;
  box-shadow: 0px 4px 20px 0px #120a3c26;
  border: 1px solid #ffffff;
  padding: 8px;
  background-color: #ffffff;
  overflow: hidden;
  overflow-y: auto;

  &::-webkit-scrollbar {
    display: none;
  }

  .phone_Item {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    overflow: hidden;
    position: relative;

    .music_box {
      position: absolute;
      top: 80px;
      right: 10px;
      width: 24px;
      height: 24px;
    }

    .header {
      width: 100%;
      z-index: 2;
    }

    .phone-content-container {
      padding: 260px 10px;
      .phone-content {
        display: flex;
        flex-direction: column;
        padding: 0px 16px;
        .txt-row {
          font-weight: 400;
          font-size: 14px;
          // color: #111111;
          line-height: 18px;
          margin-bottom: 8px;
          &:last-child {
            margin-bottom: 0px;
          }
          .txt-bold {
            display: inline-block;
            font-weight: bold;
            line-height: 20px;
            margin: 0px 8px;
          }
        }
      }
      .phone-btn-box {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        margin-top: 30px;
        .phone-btn {
          width: 166px;
          height: 33px;
          background-size: 100% 100% !important;
          background-repeat: no-repeat !important;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          font-size: 14px;
          color: #ffffff;
        }
        .tip-txt {
          font-weight: 400;
          font-size: 10px;
          color: rgba(17, 17, 17, 0.8);
          line-height: 14px;
          margin-top: 4px;
        }
      }
    }
  }
}
</style>
